package com.ervasstudio.tracoemovimento.pages.projecto


import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.sections.Footer
import com.ervasstudio.tracoemovimento.model.PopupState
import com.ervasstudio.tracoemovimento.model.UserRecoveryData
import com.ervasstudio.tracoemovimento.util.Res
import com.ervasstudio.tracoemovimento.util.Res.MyColors.PretoDesfalecido
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.objectFit
import com.varabyte.kobweb.compose.css.overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Iframe
import org.jetbrains.compose.web.dom.Video

@Composable
fun MainSectionProjecto(
    currentState: PopupState,
    onSave: (UserRecoveryData) -> Unit,
    apiErrorMessage: String? = null,
    changeApiErrorMessage: (String?) -> Unit,
    showPopup: Boolean? = false,
    changeShowPopUp: (Boolean) -> Unit,
    isMobile: Boolean,
) {
    UserRecoveryData(
        isOpen = showPopup!!,
        onClose = {
            changeShowPopUp(!showPopup)
            changeApiErrorMessage(null)
        },
        onSave = onSave,
        currentState = currentState,
        externalError = apiErrorMessage
    )

    Column(modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
        HeroProjecto(isMobile)
        Box(modifier = Modifier.height(if (isMobile) 24.px else 60.px))
        Box(modifier = Modifier.height(if (isMobile) 24.px else 100.px))

        IntroTextoProjecto(isMobile)

        VideoRow(
            ids = listOf("V8Dq6VGJtOw", "mqh-0ntQglw"),
            isMobile = isMobile,
            topPadding = if (isMobile) 32.px else 80.px,
        )
        VideoRow(
            ids = listOf("V8Dq6VGJtOw", "mqh-0ntQglw"),
            isMobile = isMobile,
            topPadding = if (isMobile) 32.px else 80.px,
        )

        VideoRow(
            ids = listOf("XtKw4cHKi_M", "FrKYeUNeWDA"),
            isMobile = isMobile,
        )
        CtaListaDeEspera(isMobile = isMobile, onClick = { changeShowPopUp(true) })

        VideoRow(
            ids = listOf("L7JG81YJ3IE", "L7JG81YJ3IE"),
            isMobile = isMobile,
        )

        VideoRow(
            ids = listOf("6oyk1nmzrA4", "6mrSbNfKaVM"),
            isMobile = isMobile,
        )

        VideoRow(
            ids = listOf("b8d7Gip3we4", "JA3_oe02_-4"),
            isMobile = isMobile,
        )

        Box(modifier = Modifier.height(if (isMobile) 40.px else 100.px))
        Footer(false, isMobile = isMobile)
    }
}